import {
  useState,
  createContext,
  useContext,
  ReactNode,
  useEffect,
} from 'react';
import { IOperationAllow } from '../interfaces';
import {
  allowAdmin,
  allowDi,
  allowApprove,
  useDeaRegistrations,
  useUserContext,
  allowHelpDesk,
} from '..';
import { map as lmap } from 'lodash/fp';
import { concatAll } from 'fp-ts/lib/Monoid';
import { MonoidAny } from 'fp-ts/lib/boolean';

interface IState {
  operations: IOperationAllow[];
}

interface IRoleOpContextProviderProps {
  defaults?: Partial<IState>;
  children?: ReactNode;
}

export const defaultState: IState = {
  operations: [
    { operation: 'approve', allow: false },
    { operation: 'admin', allow: false },
    { operation: 'di', allow: false },
    { operation: 'helpDesk', allow: false },
  ],
};

const RoleOpContext = createContext<IState>(defaultState);

export const useRoleOpContext = () => {
  return useContext(RoleOpContext);
};

export const RoleOpContextProvider = (props: IRoleOpContextProviderProps) => {
  const [operations, setOperations] = useState<IOperationAllow[]>(
    defaultState.operations
  );

  const { deaRegistrations } = useDeaRegistrations();
  const { user } = useUserContext();

  useEffect(() => {
    setOperations(
      lmap<IOperationAllow, IOperationAllow>(a =>
        a.operation === 'approve'
          ? {
              ...a,
              allow: concatAll(MonoidAny)([
                allowApprove(deaRegistrations),
                allowAdmin(user),
                allowDi(user),
                allowHelpDesk(user),
              ]),
              // allow: true,
            }
          : a
      )
    );
  }, [deaRegistrations, user]);

  useEffect(() => {
    setOperations(
      lmap<IOperationAllow, IOperationAllow>(a =>
        a.operation === 'di'
          ? {
              ...a,
              allow: concatAll(MonoidAny)([allowDi(user), allowHelpDesk(user)]),
              // allow: true,
            }
          : a.operation === 'admin'
          ? {
              ...a,
              allow: allowAdmin(user),
              // allow: true,
            }
          : a.operation === 'helpDesk'
          ? {
              ...a,
              allow: allowHelpDesk(user),
              // allow: true,
            }
          : a
      )
    );
  }, [user]);

  return (
    <RoleOpContext.Provider
      value={{
        operations,
      }}>
      {props.children}
      {/* <pre>operations: {JSON.stringify(operations, null, 2)}</pre> */}
    </RoleOpContext.Provider>
  );
};
